<template>
  <div>
    <div style="height: 70px;"></div>
    <div class="step-layer">
      <div class="step">
        <div class="step-item current">
          <div class="step-icon">1</div>
          <div class="step-title" v-text="$t('adv_common.first') + $t('adv_common.end')"></div>
        </div>
        <div class="step-line"></div>
        <div class="step-item current">
          <div class="step-icon">2</div>
          <div class="step-title" v-text="$t('adv_common.second') + $t('adv_common.end')"></div>
        </div>
        <div class="step-line"></div>
        <div class="step-item">
          <div class="step-icon">3</div>
          <div class="step-title" v-text="$t('adv_common.third')"></div>
        </div>
      </div>
    </div>

    <div class="btn">
      <div v-text="$t('create_group.title')"></div>
      <div class="group-type">
        <div class="left-title" v-text="$t('adv.td13')"></div>
        <div class="right-content">
          <el-select v-model="form.type" placeholder="select" size="mini" style="width: 120px;">
            <el-option :label="$t('adv.td14')" value="1"></el-option>
            <el-option :label="$t('adv.td15')" value="2"></el-option>
          </el-select>
        </div>
      </div>
      <div class="group-desc" v-text="$t('create_group.desc')"></div>
    </div>

    <div class="layer">
      <div class="input">
        <div class="left-title" v-text="$t('create_group.group_name')"></div>
        <div class="right-content"><el-input v-model="form.group_name" size="small" style="width: 220px" :placeholder="$t('create_group.group_name_p')"></el-input></div>
      </div>
    </div>

    <div class="layer">
      <div class="input">
        <div class="left-title" v-text="$t('create_group.keyword')"></div>
        <div class="right-content">
          <div class="date">
            <div class="date-title" v-text="$t('create_group.keyword_desc')"></div>
            <div style="margin: 10px 0;"><el-input v-model="form.url" size="small" style="width: 220px" :placeholder="$t('create_group.url')"></el-input></el-date-picker></div>
            <div><el-input v-model="form.url_title" size="small" style="width: 220px" :placeholder="$t('create_group.url_title')"></el-input></el-date-picker></div>
            <div style="margin: 10px 0;">
              <div style="color: rgba(0,0,0,.54); font-size: 13px; margin: 5px 0;" v-text="$t('create_group.keyword_title')"></div>
              <el-input type="textarea" rows="10" :placeholder="$t('create_group.keyword_line')" v-model="form.content" style="width: 60%;"></el-input>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="btn">
      <el-button type="primary" size="small" @click="save" v-text="$t('adv_common.save_btn1')"></el-button>
      <el-button type="text" @click="cancel" v-text="$t('common.layer_btn_cancel')"></el-button>
    </div>
    <div style="height: 200px;"></div>
  </div>

</template>

<script>
export default {
  name: 'createGroup',
  props: ['group_data', 'plan_id'],
  data() {
    return {
      form: {
        plan_id: '',
        group_id: '',
        type: '1',
        group_name: '',
        url: '',
        url_title: '',
        content: ''
      },
      type: 'add'
    };
  },
  created() {
    this.form.plan_id = this.plan_id;
    let title = this.$t('create_adv.create');
    if (this.group_data.group_id !== undefined && parseInt(this.group_data.group_id) > 0) {
      this.form = {
        plan_id: this.group_data.plan_id,
        group_id: this.group_data.group_id,
        type: this.group_data.type + '',
        group_name: this.group_data.group_name,
        url: this.group_data.url,
        url_title: this.group_data.url_title,
        content: this.group_data.content
      };
      this.type = 'edit';
      title = this.$t('create_adv.edit');
    }

    document.title = `${title}` + this.$t('create_group.group');
    this.$function.hiddenLoading();
  },
  methods: {
    save() {
      if (this.form.group_name === '') {
        this.$message.error(this.$t('create_group.group_name_verify'));
        return false;
      }
      if (this.form.url === '') {
        this.$message.error(this.$t('create_group.url_verify'));
        return false;
      }
      if (this.form.url_title === '') {
        this.$message.error(this.$t('create_group.url_title_verify'));
        return false;
      }
      if (this.form.content === '') {
        this.$message.error(this.$t('create_group.content_verify'));
        return false;
      }
      const url = this.type === 'add' ? '/trader/index/createGroupPlan' : '/trader/index/saveGroupPlan';
      this.$http.post(url, this.form).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('create_adv.success'));
          this.type === 'add' ? this.$emit('group_call_back', res.group_id) : this.cancel();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    cancel() {
      this.$emit('jump_adv', 'GroupView');
    }
  }
};
</script>

<style lang="less" scoped="">
  .btn {
    width: 1088px;
    margin: 40px auto;
    font-size: 15px;
    color: #222;
    .group-type {
      margin: 20px 0;
      font-size: 14px;
      display: flex;
      align-items: center;
      .right-content {
        margin-left: 20px;
      }
    }
    .group-desc {
      color: rgba(32,33,36,.86);
      font-size: 13px;
    }
  }
  .layer {
    width: 1024px;
    padding: 24px 32px;
    margin: 30px auto;
    background: #fff;
    font-size: 14px;
    box-shadow: 0 6px 10px 0 rgba(0,0,0,.14), 0 1px 18px 0 rgba(0,0,0,.12), 0 3px 5px -1px rgba(0,0,0,.2);
    .date {
      margin-bottom: 20px;
      .date-title {
        color: rgba(0,0,0,.54);
        margin-bottom: 5px;
        font-size: 14px;
      }
    }
    .input {
      display: flex;
      align-items: flex-start;
      .left-title {
        width: 220px;
        color: #212121;
      }
      .right-content {
        width: calc(100% - 220px);
        position: relative;
        .select-type {
          display: flex;
          margin-bottom: 16px;
          .right-body {
            color: #5f6368;
            padding: 0 20px;
            .title {
              font-weight: bold;
              font-size: 15px;
              margin-bottom: 16px;
            }
            .content, .desc {
              font-size: 12px;
              margin-bottom: 16px;
            }
          }
        }
        .right-data-font {
          height: 80px;
          font-size: 13px;
          color: #5f6368;
          position: absolute;
          bottom: 0;
          right: 0;
          padding-left: 16px;
          border-left: 1px solid #dadce0;
          div {
            margin-bottom: 8px;
          }
        }
      }
    }
    .one-line {
      color: #212121;
      .title {
        color: #757575;
      }
    }

    .checkbox {
      .check-item {
        margin-top: 8px;
      }
    }
  }

  .step-layer {
    width: 100%;
    background: #fff;
    height: 70px;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.12), 0 1px 5px 0 rgba(0,0,0,.2);
    display: flex;
    align-items: center;
    position: fixed;
    top: 66px;
    background: #fff;
    z-index: 2;
    .step {
      margin-left: 30px;
      display: flex;
      align-items: center;
      .step-item {
        display: flex;
        align-items: center;
        font-size: 14px;
        .step-icon {
          width: 28px;
          height: 28px;
          text-align: center;
          line-height: 28px;
          color: #fff;
          background: #616161;
          border-radius: 50%;
          font-size: 12px;
          margin-right: 8px;
        }
      }
      .step-line {
        width: 50px;
        height: 1px;
        background: #BDBDBD;
        margin: 0 8px;
      }
      .current {
        .step-icon {
          background: #4285F4;
        }
      }
    }
  }
</style>
